import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../context/LanguageContext';

interface SEOProps {
    titleKey?: string;
    descriptionKey?: string;
}

const SEO: React.FC<SEOProps> = ({
    titleKey = 'SparkSkool – The AI Platform Schools Trust',
    descriptionKey = 'AI that gives time back to teachers and opportunity back to students.'
}) => {
    const { t, language, direction } = useTranslation();

    const title = t(titleKey);
    const description = t(descriptionKey);

    return (
        <Helmet htmlAttributes={{ lang: language, dir: direction }}>
            <title>{title}</title>
            <meta name="description" content={description} />

            {/* Open Graph / Social Media Meta Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:type" content="website" />

            {/* Twitter Card Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
};

export default SEO;
